module.exports = __webpack_public_path__ + "assets/elections_white.82342d99.svg";